import React from 'react';
import { SectionWrapper } from '../../components';
import { SECTION } from '../../constants/sections';
import { Theme } from '../../constants/styles';
import photo from '../../assets/images/photo.png';
import './About.scss';

const About = () => {
  return (
    <SectionWrapper
      section={SECTION.about}
      theme={Theme.Light}
      fullLength={true}
    >
      <div className="about-banner">
        <img src={photo} alt="Yevhenii" />
      </div>
      <div className="text">
        <p>
          I’m Yevhenii Volotskov — a software engineer who cuts through the
          noise to build web experiences that actually work and feel right. No
          clutter, no gimmicks — just clean code, sharp thinking, and a drive to
          make things better than they were yesterday. I work full-stack,
          combining Java, React, CMS platforms, and AWS to build scalable,
          user-focused solutions.
        </p>
      </div>
    </SectionWrapper>
  );
};

export default About;
